module.exports = __webpack_public_path__ + "img/1-12.26f0a0c6.jpg";